import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { documentTypes, DOCUMENT_TAGS } from "@/js/lists.ts";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
export default {
  name: "ProducerAttachedFilesDrawer",
  props: {
    id: Number
  },
  data: function data() {
    return {
      drawer: false,
      isMakingDrawerStateless: false,
      isLoadingProducerFiles: false,
      producerFiles: [],
      gettingDocumentTags: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      uploadAdditionalData: {
        tagId: null
      },
      documentTypes: documentTypes,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/producers/").concat(this.id, "/files");
    },
    uploadAdditionalFormData: function uploadAdditionalFormData() {
      return _objectSpread({}, this.uploadAdditionalData);
    }
  },
  components: {
    UploaderV2: UploaderV2,
    confirm: confirmationComponent,
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    AddTagToDocumentDialog: AddTagToDocumentDialog,
    ErrorModal: ErrorModal
  },
  created: function created() {
    this.fetchProducerFiles();
  },
  methods: {
    openDrawer: function openDrawer() {
      this.drawer = true;
      this.fetchDocumentTags();
    },
    closeDrawer: function closeDrawer() {
      this.drawer = false;
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    fetchProducerFiles: function fetchProducerFiles() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _this2.isLoadingProducerFiles = true;
              _context.next = 4;
              return request("/v1/producers/".concat(_this2.id, "/files"), "get", null, true, "api", null, _this2.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.isLoadingProducerFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context.sent;
              if (response) _this2.producerFiles = _toConsumableArray(response.data.value);
              _this2.isLoadingProducerFiles = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    upload: function upload() {
      this.fetchProducerFiles();
      this.uploadAdditionalData.tagId = null;
    },
    removeFile: function removeFile(id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isMakingDrawerStateless = true;
              _context2.next = 3;
              return _this3.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context2.sent;
              if (!confirmed) {
                _context2.next = 10;
                break;
              }
              _this3.isLoadingProducerFiles = true;
              _this = _this3;
              _context2.next = 9;
              return request("/v1/producers/".concat(_this3.id, "/files/").concat(id), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to remove this file.", {
                  type: "error"
                });
                _this.isLoadingProducerFiles = false;
                throw e;
              });
            case 9:
              _this3.fetchProducerFiles();
            case 10:
              _this3.isMakingDrawerStateless = false;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$gettingDocumen;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.gettingDocumentTags.isPending = true;
              (_this4$gettingDocumen = _this4.gettingDocumentTags.cancellationToken) === null || _this4$gettingDocumen === void 0 || _this4$gettingDocumen.cancel();
              _this4.gettingDocumentTags.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 6;
              return request("/v1/document-tags/all", "get", null, true, "api", null, _this.gettingDocumentTags.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of tags", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              response = _context3.sent;
              _this4.gettingDocumentTags.results = _toConsumableArray(response.data.items);
              _this4.gettingDocumentTags.results = _this4.gettingDocumentTags.results.filter(function (x) {
                return x.id !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId;
              });
              _this4.gettingDocumentTags.isPending = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.WINERY);
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this5;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!confirm) {
                          _context4.next = 3;
                          break;
                        }
                        _context4.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.WINERY.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (_) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchProducerFiles();
      this.fetchDocumentTags();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    }
  }
};